import { isAfter } from 'date-fns';
import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { RelativeTime } from '@bonusly/common-relative-time';
import { Box, Flex } from '@bonusly/design-system';

import { useEvaluation } from './context';

export const PendingBadge: FC = () => {
	const { t } = useTranslation('feedback');
	const evaluation = useEvaluation();
	const isExpired = evaluation.isExpiringSoon() || evaluation.isExpired();
	const context = isAfter(new Date(), evaluation.expiresAt) ? 'past' : 'future';

	if (!evaluation.isPending()) {
		return null;
	}

	return (
		<Flex alignItems="center">
			<Box
				border="1px solid"
				borderColor="bg.soft"
				borderRadius="sm"
				color="text.soft"
				fontSize="sm"
				px={2}
				py="2px"
				{...(isExpired && {
					bg: 'error.closeBg',
					borderColor: 'none',
					color: 'error.text',
				})}
			>
				<Trans i18nKey={'pending.expires' as any} context={context} t={t}>
					Expires in
					<RelativeTime date={evaluation.expiresAt} fontSize="sm" />
				</Trans>
			</Box>
		</Flex>
	);
};
